import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
	name: 'tcCurrency',
	standalone: true,
})
export class TcCurrencyPipe implements PipeTransform {

	constructor(
		private currencyPipe: CurrencyPipe,
	) { }
	
	transform(value: number | string, precision: number = 8, truncate: boolean = false): any {
		let val = typeof value === 'number' ? value : this.removeAmountSeparator(value);
		if (truncate) {
			val = this.truncate(val, precision);
		}
		return this.currencyPipe.transform(val, null, '', `.0-${precision}`);
	}

	private removeAmountSeparator(value: string | number | null | undefined): number {
		if (value === null || value === undefined) return 0;
		if (typeof value === 'number') return value;

		const s = String(value).trim();
		if (!s) return 0;

		// convert persian number (۰-۹) to english number
		const normalized = s.replace(/[۰-۹]/g, ch =>
			String.fromCharCode(ch.charCodeAt(0) - 1728)
		);

		// remove amount separator
		const result = parseFloat(normalized.replace(/,/g, ''));
		return Number.isFinite(result) ? result : 0;
	}

	private truncate(value: number, precision: number): number {
		const factor = Math.pow(10, precision);
		return Math.trunc(value * factor) / factor;
	}

}
